import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CaracterizacionFormateada } from '../../../interfaces/caracterizacion-formateada.interface';

@Component({
    selector: 'app-visualizar-caracterizacion-empresa',
    templateUrl: './visualizar-caracterizacion-empresa.component.html',
    styleUrls: ['./visualizar-caracterizacion-empresa.component.css'],
    standalone: true,
    imports: [CommonModule],
})
export class VisualizarCaracterizacionEmpresaComponent {
    @Input() public empresa: {
        nit?: string;
        razonSocial?: string;
        tipo?: string;
    } | null = null;

    @Input() public caracterizacion: CaracterizacionFormateada | null = null;

    public constructor(public activeModal: NgbActiveModal) {}

    /** Indica si la caracterización tiene los datos esenciales (no parcial). */
    public tieneDatosCaracterizacionCompleta(): boolean {
        const d = this.caracterizacion;
        if (!d) return false;

        const vacio = (v: unknown): boolean =>
            v === null ||
            v === undefined ||
            (typeof v === 'string' &&
                ['', 'no disponible', 'no registrado'].includes(
                    v.trim().toLowerCase()
                ));

        const requeridos: Array<keyof typeof d> = [
            'gruposProductos',
            'puntosVenta',
            'personalEmpresa',
            'montoPromedio',
        ];

        return requeridos.every((campo) => !vacio(d[campo]));
    }

    getTipoComercializador(tamanoComercializador?: string | null): string {
        if(tamanoComercializador === 'Pequeño')
            return 'Pequeño comercializador';

        if(tamanoComercializador === 'Mediano')
            return 'Mediano comercializador';
        
        if(tamanoComercializador === 'Grande')
            return 'Gran Comercializador';
        
        return 'No asignado';
    }
}
